import React from "react"
import { useTranslation } from "react-i18next"
import { Button } from "./button"
import AvatarImage, { participantPhotoToSrc } from "@/components/AvatarImage"
import { Profile } from "@/reducers/profilesSlice"

type DriverButtonProps = {
  chatName: string
  driver?: Profile
  avatarColor: string
  avatarName: string
  isCoDriver: boolean
  isSharedDriver: boolean
  onClick: () => void
}

const DriverButton = ({
  driver,
  chatName,
  avatarName,
  avatarColor,
  isCoDriver,
  onClick,
}: DriverButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button
      variant="outline"
      onClick={onClick}
      className="max-h-5 rounded-full px-1.5 py-1"
      size="sm"
    >
      {isCoDriver && `${t("chatHeader.coDriver")} `}
      {chatName}
      <AvatarImage
        size="xxsmall"
        name={avatarName}
        color={avatarColor}
        src={participantPhotoToSrc(driver?.photo)}
      />
    </Button>
  )
}

export default React.memo(DriverButton)
